import { DriveView } from './drive/components/DriveView'
import { useUserFilesPollingProcessor } from './polling/hooks/useUserFilesPollingProcessor'
import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { AuthContext } from '@/context/auth-context'

/**
 * UserFilesPage
 *
 * Main page for the user files feature, housing the folder browser (DriveView)
 * and all folder management functionality.
 */
export default function UserFilesPage() {
  const { user } = useContext(AuthContext)
  const { matterId } = useParams<{ matterId: string }>()
  useUserFilesPollingProcessor()

  return <DriveView key={`${user?.uid ?? ''}:${matterId ?? ''}`} />
}
